import { Button } from '@/components/common/button'
import { Note } from '@/components/common/note'

interface CrosschainFailedStateProps {
  error?: Error | null
  onRetry?: () => void
}

export const CrosschainFailedState = ({ error, onRetry }: CrosschainFailedStateProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Note color="red" className="break-words">
        <p className="inline-block first-letter:uppercase">
          {error?.message || 'Your crosschain transaction failed. Please try again.'}
        </p>
      </Note>
      {onRetry && (
        <Button type="button" size="sm" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  )
}
